import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Sarah Jenkins',
    role: 'Health Enthusiast',
    content: "I've been looking for an app like this for years! It makes grocery shopping so much easier. I instantly know what to avoid without reading tiny labels.",
    rating: 5
  }, {
    name: 'Mike Chen',
    role: 'Fitness Coach',
    content: "IntelliEats is a game changer for my clients. The 'Ingredients to Avoid' feature is spot on and helps people make better choices immediately.",
    rating: 5
  }, {
    name: 'Emily Rodriguez',
    role: 'Mom of two',
    content: 'With kids who have allergies, this app is a lifesaver. The scanning is super fast and the breakdown is easy to understand. Highly recommend!',
    rating: 5
  }];
  return <section id="reviews" className="py-20 bg-brand-50/50" data-id="element-2959" data-mp="qalipwygt5tf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2960" data-mp="qb511es11w7z">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2961" data-mp="h5opb9y5y46w">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-2962" data-mp="m51dby0rthb2">
            Loved by Health-Conscious Eaters
          </h2>
          <p className="text-lg text-slate-600" data-id="element-2963" data-mp="78tv338xapyf">
            Join thousands of users who are taking control of their nutrition.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-2964" data-mp="c8oigwthoxeq">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-2965" data-mp="zysfglc69ywr" data-mpi={index}>
              <div className="flex text-accent-500 mb-4" data-id="element-2966" data-mp="q6cwplt1x6at">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-2967" data-mp="v3d1zui2u50v" data-mpi={i} />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-2968" data-mp="1nm0ggr2kilsz">
                "{review.content}"
              </p>
              <div data-id="element-2969" data-mp="1xiipsomnt6f0">
                <div className="font-bold text-slate-900" data-id="element-2970" data-mp="1xgpl3evlww9n">{review.name}</div>
                <div className="text-sm text-slate-500" data-id="element-2971" data-mp="1sie84va0m5n7">{review.role}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}